"use client";
import Image from "next/image";
import Link from "next/link";
import { StepProps } from "../../Steps.types";

export default function Steps_About_Layout5({ data }: StepProps) {
 
  const steps = Array.isArray(data?.Step) ? data.Step : [];

  return (
    <div className="px-6 py-8 md:px-24 lg:px-8 lg:py-10 bg-th-bg-col">
      <div className="max-w-xl mx-auto mb-10 text-center lg:max-w-2xl">
        <h1 className="text-3xl xl:text-4xl font-bold text-[#1f1f1f]">
          {data?.title || "Title"}
        </h1>
        <p className="mt-4 text-lg text-[#797979]">
          {data?.description || ""}
        </p>
      </div>

      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col space-y-8">
          {steps.length === 0 ? (
            <p className="text-center text-gray-500 py-6">
              No steps available.
            </p>
          ) : (
            steps.map((item, idx) => {
              const imageUrl = item?.iconImage?.data?.attributes?.url || "";
              const altText =
                item?.iconImage?.data?.attributes?.alternativeText ||
                "Step Image";

              return (
                <div
                  key={idx}
                  className="flex flex-col md:flex-row items-center bg-white rounded-2xl shadow-lg overflow-hidden"
                >
                  {/* Image Section */}
                  <div className="w-full md:w-1/4 relative">
                    <div className="absolute top-0 left-0 bg-black text-white text-4xl font-bold w-16 h-16 flex items-center justify-center">
                      {idx + 1}
                    </div>

                    {imageUrl ? (
                      <Image
                        src={imageUrl}
                        alt={altText}
                        width={400}
                        height={400}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full min-h-[200px] bg-gray-100 flex items-center justify-center text-gray-400">
                        No Image
                      </div>
                    )}
                  </div>

                  {/* Text Section */}
                  <div className="w-full md:w-3/4 p-8">
                    <h3 className="text-2xl font-bold text-[#1f1f1f] mb-4">
                      {item?.title || "Untitled"}
                    </h3>

                    <p className="text-[#797979] mb-6">
                      {item?.text || ""}
                    </p>

                    {item?.href && (
                      <Link
                        href={item.href}
                        className="inline-block px-6 py-3 text-sm font-semibold text-white bg-black rounded-full hover:bg-gray-800 transition"
                      >
                        {item?.hrefText || "Learn More"}
                      </Link>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
